export const BOOLEAN_VALUE_OPTIONS = [
	{ value: 'true', label: 'True' },
	{ value: 'false', label: 'False' },
] as const;

export const EAS_INFO_BOOLEAN_TYPE = 'BOOLEAN';

export const EAS_INFO_NUMBER_TYPE = 'NUMBER';

export const LONG_TEXT_VALUE_THRESHOLD = 80;

export const isLongTextValue = (value: string): boolean => value.length > LONG_TEXT_VALUE_THRESHOLD;
